module.exports = __webpack_public_path__ + "img/interact-teacher-stop-btn.cce050cd.png";